import { cloneElement, ReactElement, FC, PropsWithChildren } from 'react';

import { useMe } from 'graphql/hooks/user';

const WithAdmin: FC<PropsWithChildren> = ({ children, ...rest }) => {
  const { isAdmin } = useMe();

  if (!isAdmin) {
    return null;
  }

  return !!children ? cloneElement(children as ReactElement, rest) : null;
};

export default WithAdmin;
